<template>
	<div>
		<v-dialog
			:value="true"
			max-width="400"
			@click:outside="handleClose"
			@keydown.esc="handleClose"
		>
			<v-card>
				<ValidationObserver ref="form" tag="form" @submit="handleSubmit">
					<v-container>
						<v-row>
							<v-col>
								<ValidationProvider rules="required" v-slot="{ errors }">
									<v-text-field
										v-model="organizationEditable.name"
										outlined
										:label="$t('label.name')"
										:error-messages="errors"
										hide-details
										dense
									></v-text-field>
								</ValidationProvider>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<fieldset
									class="talentics-fieldset talentics-fieldset-paddings"
								>
									<legend>
										{{ $t('label.status') }}:
										{{
											organizationEditable.active
												? $t('label.active')
												: $t('label.inactive')
										}}
									</legend>
									<v-switch
										v-model="organizationEditable.active"
										color="success"
										inset
										hide-details
										dense
										class="v-input--template-switch"
									></v-switch>
								</fieldset>
							</v-col>
						</v-row>
					</v-container>
				</ValidationObserver>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="handleClose">{{
						$t('button.close')
					}}</v-btn>
					<v-btn
						color="error"
						outlined
						@click="hanleDeleteClick"
						v-if="method === 'edit'"
						>{{ $t('button.delete') }}</v-btn
					>
					<v-btn color="primary" @click="handleSubmit">{{
						$t('button.save')
					}}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<Confirm
			v-if="isDeleteConfirmVisible"
			:onConfirm="handleConfirmDialogConfirm"
			:onClose="handleConfirmDialogClose"
			primaryActionColor="error"
			><div style="padding-top: 20px">
				{{ $t('text.confirm-deleting-organization') }}
			</div></Confirm
		>
	</div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import Confirm from '@/components/shared/dialogs/confirm/Confirm';

export default {
	name: 'DepartmentAttrs',
	components: {
		ValidationObserver,
		ValidationProvider,
		Confirm,
	},
	props: {
		method: {
			type: String,
			required: true,
		},
		organization: {
			type: Object,
			required: false,
			default() {
				return {
					active: true,
					name: '',
				};
			},
		},
		onClose: {
			type: Function,
			required: true,
		},
	},
	data() {
		const { organization } = this;
		return {
			organizationEditable: JSON.parse(JSON.stringify(organization)),
			isDeleteConfirmVisible: false,
		};
	},
	methods: {
		handleClose() {
			this.onClose();
		},
		async handleSubmit(evt) {
			if (evt) {
				evt.preventDefault();
			}
			const isValid = await this.$refs.form.validate();
			if (isValid) {
				const { organizationEditable, method } = this;
				if (method === 'edit') {
					this.$store
						.dispatch('organizations/put', {
							items: [{ ...organizationEditable }],
						})
						.then(() => {
							this.handleClose();
						});
				} else if (method === 'add') {
					this.$store
						.dispatch('organizations/post', {
							items: [{ ...organizationEditable }],
						})
						.then(() => {
							this.handleClose();
						});
				}
			}
		},
		handleConfirmDialogConfirm() {
			const { id } = this.organizationEditable;
			this.$store.dispatch('organizations/delete', { id }).then(() => {
				this.handleClose();
			});
		},
		handleConfirmDialogClose() {
			this.isDeleteConfirmVisible = false;
		},
		hanleDeleteClick() {
			this.isDeleteConfirmVisible = true;
		},
	},
	watch: {
		organization(newVal) {
			this.organizationEditable = { ...newVal };
		},
	},
};
</script>
